export default "__VITE_ASSET__CKCX4BSR__"